import { z } from 'zod';
import { zodRequiredString } from '../../utils/zod';

export const MEDICINE_TYPES = ['内', '外', '注', '歯'] as const;

const MAX_LENGTH = 255;
const JAN_CODE_MAX = 13;

export const addMedicineSchema = z.object({
  medicineName: zodRequiredString().max(MAX_LENGTH, `最大${MAX_LENGTH}文字で入力してください。`),
  janCode: z.preprocess(
    (v) => (typeof v === 'string' ? v.replace(/\s/g, '') : v),
    zodRequiredString()
      .max(JAN_CODE_MAX, `最大${JAN_CODE_MAX}文字で入力してください。`)
      .regex(/^\d+$/, '数字のみで入力してください')
  ),
  salesManufacturer: zodRequiredString().max(
    MAX_LENGTH,
    `最大${MAX_LENGTH}文字で入力してください。`
  ),
  capacity: zodRequiredString().max(MAX_LENGTH, `最大${MAX_LENGTH}文字で入力してください。`),
  yjCode: z
    .string()
    .max(MAX_LENGTH, `最大${MAX_LENGTH}文字で入力してください。`)
    .regex(/^[0-9A-Za-z]*$/, '半角英数字のみで入力してください')
    .optional(),
  gs1Code: z
    .string()
    .max(MAX_LENGTH, `最大${MAX_LENGTH}文字で入力してください。`)
    .regex(/^[0-9A-Za-z]*$/, '半角英数字のみで入力してください')
    .optional(),
  medicineType: z.enum(MEDICINE_TYPES).or(z.literal('')).optional(),
  note: z.string().max(MAX_LENGTH, `最大${MAX_LENGTH}文字で入力してください。`).optional(),
});

export type AddMedicineSchema = z.infer<typeof addMedicineSchema>;
